import React, { useMemo } from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';

import {
  isEmptyCollection,
  isUrlNamesMatch,
  SiteConfigManager,
  useCategoryState,
} from '@atlas/core';
import { EmptyStateView, SimpleSearchSkeleton, SimpleTournamentSkeleton } from '@atlas/ui';

import { useSimpleSearchState } from 'components/Search';

import SimplifiedTournaments from './SimplifiedTournaments';

const SimplifiedTournamentsList = () => {
  const { tournamentName } = useParams();
  const { initialized, loading, tournaments } = useCategoryState();
  const { params } = useRouteMatch();

  const { isOpened } = useSimpleSearchState();

  const isEnableFavouritesInSimplified = SiteConfigManager.getConfig(
    'config.config.sportsbook.enableFavouritesInSimplified',
  );

  const selectedTournamentId = useMemo(
    () =>
      tournaments.find(({ urlName }) => urlName && isUrlNamesMatch(params.tournamentName, urlName))
        ?.id,
    [tournaments, params.tournamentName],
  );

  const filteredTournaments = useMemo(() => {
    if (!selectedTournamentId) {
      return tournaments;
    }

    return tournaments.filter(({ id }) => id === selectedTournamentId);
  }, [tournaments, selectedTournamentId]);

  if (!initialized && loading) {
    if (tournamentName) {
      return (
        <SimpleTournamentSkeleton
          minimized
          outcomesNumber={1}
          withFavorite={isEnableFavouritesInSimplified}
        />
      );
    }

    return <SimpleSearchSkeleton outcomesNumber={1} />;
  }

  if (isEmptyCollection(tournaments) && !isOpened) {
    return (
      <EmptyStateView description="sportsbook_empty_description" title="sportsbook_no_events" />
    );
  }

  return (
    <div className="tournaments-container">
      <SimplifiedTournaments tournaments={filteredTournaments} />
    </div>
  );
};

export default SimplifiedTournamentsList;
